import React, {Component} from 'react';
import ListDesignerHoc from "../../../HocHelpers/ListDesignerHoc";
import List from "./List";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = () => ({
    wrapper: {
        height: '100%',
        width: '100%'
    },
    wrapperModal: {
        height: '100%',
        width: '100%'
    }
});

class ScreenBar extends Component {
    render() {
        const {classes, modal} = this.props;
        return (
            <div className={modal ? classes.wrapperModal : classes.wrapper}>
                <List/>
            </div>
        );
    }
}

export default ListDesignerHoc(withStyles(styles)(ScreenBar));